export class CustomerUser {
  bAdmin: boolean;
  bEditor: boolean;
  bOK: boolean;
  bSupervisor: boolean;
  sCustomerID: string;
  sLangID: string;
  sUserEmail: string;
  sUserFirstName: string;
  sUserGroup: string;
  sUserID: string;
  sUserLastName: string;
  sUserPwd: string;
  title: string;
  adminUsers: boolean;
  adminExpress: boolean;
  adminErl: boolean;
  adminEmail: boolean;
  adminLog: boolean;
  businessCategory : string;
  constructor() {
  }
}
